import { Button, Divider, Flex, Grid, Input, Text } from "@mantine/core";
import { IconDownload } from "@tabler/icons";
import { useSelector } from "react-redux";
import { IGeneral } from "../../interfaces/IGeneral";
import { IReference } from "../../models/General";
import { currencyFormat } from "../../utils";
import { dateTimeFormat } from "../../utils/date";
import { Tag } from "../tags";

export const TabInvoiceRequestFunding = ({ data }: { data: any }) => {
  const { invoiceStatus, invoicePaymentStatus, invoiceOverdueStatus } = useSelector((state: { general: IGeneral }) => state.general);

  return (
    <div>
      <Grid>
        <Grid.Col span={12}>
          <Divider
            label={
              <Text color="golomt" fw={600} size={"md"}>
                Ерөнхий мэдээлэл
              </Text>
            }
          />
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нэхэмжлэхийн код:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500} color="golomt">
              #{data?.invRefCode || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нэхэмжлэх илгээсэн:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.invSenderUser?.lastName ? data?.invSenderUser?.lastName[0] + "." : ""}
              {data?.invSenderUser?.firstName || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нэхэмжлэх баталсан:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.invConfirmedUser?.lastName ? data?.invConfirmedUser?.lastName[0] + "." : ""}
              {data?.invConfirmedUser?.firstName || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Баталсан дүн:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {currencyFormat(data?.invConfirmedAmount || 0)}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Төлсөн дүн:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {currencyFormat(data?.invPaidAmount || 0)}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нэхэмжлэхийн үлдэгдэл:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {currencyFormat(data?.invAmountToPay || 0)}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нэхэмжлэх төлөв:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {Tag(
                invoiceStatus?.find((item: IReference) => item.code === data?.invStatus)?.color || "gray",
                invoiceStatus?.find((item: IReference) => item.code === data?.invStatus)?.name || "-",
              )}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Төлбөрийн төлөв:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <div>
              {Tag(
                invoicePaymentStatus?.find((item: IReference) => item.code === data?.invPaymentStatus)?.color || "gray",
                invoicePaymentStatus?.find((item: IReference) => item.code === data?.invPaymentStatus)?.name || "-",
              )}
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Хугацаа хэтрэлтийн төлөв:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <div>
              {Tag(
                invoiceOverdueStatus?.find((item: IReference) => item.code === data?.invOverdueStatus)?.color || "gray",
                invoiceOverdueStatus?.find((item: IReference) => item.code === data?.invOverdueStatus)?.name || "-",
              )}
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Төлбөрийн нөхцөл:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.invPaymentTermDesc || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нэхэмжлэх төлөх огноо:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.invPaymentDate ? dateTimeFormat(data?.invPaymentDate) : "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нэхэмжлэхийн баримт:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <div>
              <Button disabled variant="light" size="xs" leftIcon={<IconDownload size={18} color="#15AABF" />}>
                INV_3222.PDF
              </Button>
            </div>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col span={12}>
          <Divider
            label={
              <Text c="golomt" fw={600} size={"md"}>
                Нийлүүлэгч талын мэдээлэл
              </Text>
            }
          />
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Партнерийн нэр:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Flex gap={8}>
              <Text fz="sm" fw={500}>
                {data?.type === "SUPPLIER" ? (
                  <>{data?.requestedBusiness?.partner?.businessName || "-"}</>
                ) : (
                  <>{data?.invReceiverBusiness?.partner?.businessName || "-"}</>
                )}
              </Text>
              <Text fz="sm" fw={500} color="golomt">
                # {data?.type === "SUPPLIER" ? <>{data?.requestedBusiness?.partner?.refCode}</> : <>{data?.invReceiverBusiness?.partner?.refCode}</>}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Татвар төлөгчийн дугаар:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.type === "SUPPLIER" ? <>{data?.requestedBusiness?.regNumber}</> : <>{data?.invReceirverBusiness?.refCode}</>}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нийлүүлэгч бизнес:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            {data?.type === "SUPPLIER" ? (
              <Flex gap={8}>
                <Text fz="sm" fw={500}>
                  {data?.requestedBusiness?.profileName}
                </Text>
                ,{" "}
                <Text fz="sm" fw={500} color="golomt">
                  #{data?.requestedBusiness?.refCode}
                </Text>
              </Flex>
            ) : (
              <>
                <Flex gap={8}>
                  <Text fz="sm" fw={500} color="golomt">
                    {data?.invReceiverBusiness?.profileName}
                  </Text>
                  ,
                  <Text fz="sm" fw={500}>
                    #{data?.invReceiverBusiness?.refCode}
                  </Text>
                </Flex>
              </>
            )}
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Нийлүүлэгчийн данс:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.requestedBusinessAcc?.name || "-"}, {data?.requestedBusinessAcc?.number || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Борлуулалтын захиалга:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.salesOrder?.refCode || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Санхүүгийн ажилтан:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.requestedFinUser?.lastName ? data?.requestedFinUser?.lastName[0] + "." : ""}
              {data?.requestedFinUser?.firstName || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>

        <Grid.Col span={12}>
          <Divider
            label={
              <Text fw={600} size={16} color={"golomt"}>
                Худалдан авагч талын мэдээлэл
              </Text>
            }
          />
        </Grid.Col>

        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Партнерийн нэр:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Flex gap={8}>
              <Text fz="sm" fw={500}>
                {data?.invReceiverBusiness?.partner?.businessName || "-"}
              </Text>
              <Text fz="sm" fw={500} color="golomt">
                #{data?.invReceiverBusiness?.partner?.refCode || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>

        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Татвар төлөгчийн дугаар:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.invReceiverBusiness?.regNumber || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>

        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Худалдан авагч бизнес:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Flex align={"center"} gap={8}>
              <Text fz="sm" fw={500}>
                {data?.invReceiverBusiness?.profileName || "-"},
              </Text>
              <Text fz="sm" fw={500} color="golomt">
                #{data?.invReceiverBusiness?.refCode || "-"}
              </Text>
            </Flex>
          </Input.Wrapper>
        </Grid.Col>

        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Худалдан авагч данс:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.invReceiverBusinessAcc?.name || "-"}, {data?.invReceiverBusinessAcc?.number || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Худалдан авалтын захиалга:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.purchaseOrder?.refCode || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col sm={12} md={6} lg={4}>
          <Input.Wrapper
            label="Санхүүгийн ажилтан:"
            styles={{
              label: {
                fontWeight: 400,
                marginBottom: 5,
                color: "#424242",
              },
            }}>
            <Text fz="sm" fw={500}>
              {data?.finUser?.lastName ? data?.finUser?.lastName[0] + ". " : ""} {data?.finUser?.firstName || "-"}
            </Text>
          </Input.Wrapper>
        </Grid.Col>
      </Grid>
    </div>
  );
};
